import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

// HACK: Sorry, I'm so bad, but I had to
class SearchDropdown extends Dropdown {}
SearchDropdown.propTypes = Object.assign({}, Dropdown.propTypes, {
  noResultsMessage: PropTypes.node
});

export default SearchDropdown;



// WEBPACK FOOTER //
// ./src/component/SearchDropdown.js